var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "pushover-integrate-modal",
        title: _vm.$t("integrations.pushoverIntegration"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        footer: null,
      },
      on: {
        cancel: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c("div", { staticClass: "form-container" }, [
        _c("div", { staticClass: "pushover-description-box" }, [
          _c("span", { staticClass: "pushover-description-box__icon" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "pushover-description-box__text" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("integrations.pushoverDescription")) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.pushoverChannels.length > 0
          ? _c(
              "div",
              { staticClass: "existing-channels mb-4" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$t("integrations.existingChannels"))),
                ]),
                _vm._v(" "),
                _vm._l(_vm.pushoverChannels, function (channel) {
                  return _c(
                    "div",
                    { key: channel._id, staticClass: "channel-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "channel-info" },
                        [
                          _c("span", { staticClass: "channel-name" }, [
                            _vm._v(_vm._s(channel.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: channel.enabled ? "green" : "red",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    channel.enabled
                                      ? _vm.$t("common.active")
                                      : _vm.$t("common.inactive")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "channel-actions" },
                        [
                          _c("a-switch", {
                            attrs: { checked: channel.enabled },
                            on: {
                              change: function (checked) {
                                return _vm.toggleChannel(channel, checked)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", danger: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteChannelConfirm(channel)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "new-channel-form" },
          [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("integrations.createNewChannel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-form",
              { attrs: { form: _vm.form, layout: "vertical" } },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("integrations.channelName") } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "name",
                            {
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("integrations.requiredField"),
                                },
                              ],
                            },
                          ],
                          expression:
                            "['name', { rules: [{ required: true, message: $t('integrations.requiredField') }] }]",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.pushoverChannelNamePlaceholder"
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("integrations.pushoverUserKey") } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "userKey",
                            {
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("integrations.requiredField"),
                                },
                              ],
                            },
                          ],
                          expression:
                            "['userKey', { rules: [{ required: true, message: $t('integrations.requiredField') }] }]",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.pushoverUserKeyPlaceholder"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "helper-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("integrations.pushoverUserKeyHelper")) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("integrations.pushoverAppToken") } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "appToken",
                            {
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("integrations.requiredField"),
                                },
                              ],
                            },
                          ],
                          expression:
                            "['appToken', { rules: [{ required: true, message: $t('integrations.requiredField') }] }]",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.pushoverAppTokenPlaceholder"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "helper-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("integrations.pushoverAppTokenHelper")
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.close } },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("common.cancel")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", loading: _vm.loading },
              on: { click: _vm.createChannel },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("integrations.createChannel")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }